<template>
    
    <evp-header />

    <div class="mx-auto w-[calc(100vw-30px)] lg:w-[calc(100vw-100px)] xl:max-w-[1300px]">
        <div class="h-12 w-full"></div>

        <div class="notifications mt-3 mb-3 md:mt-1 md:mb-5">
            <alert v-if="evp.initialMessages.warning" type="warning">
                <span v-html="evp.initialMessages.warning"></span>
            </alert>

            <template v-if="evp.initialMessages.errors">
                <alert v-for="(errorMessage, index) in evp.initialMessages.errors" :key="index" type="error">
                    <span v-html="errorMessage"></span>
                </alert>
            </template>

            <alert v-if="evp.initialMessages.success" type="success">
                <span v-html="evp.initialMessages.success"></span>
            </alert>
        </div>

        <slot></slot>
    </div>

</template>
<script setup>
    import EvpHeader from '@/components/EvpHeader.vue'
    import Alert from '@/components/Alert.vue'
    
    const evp = window.evp

</script>
